import { paymentGuideModule } from './features/taxdb/payment-guide-module'
import { folderOrganizerSettingsModule } from './features/st-folder-viewer/folder-organizer-settings-module'
import { defineProcesses } from '@st/redux'
import type { AppType } from './features/app-type'

import { analyticsModule } from './features/analytics/module'
import { authModule } from './features/auth/auth-module'
import { oauthLoginModule } from './features/auth/oauth-login-module'
import { organizationBillingModule } from './features/billing/organization-billing-module'
import { clientPacketsModule } from './features/client-packets/client-packets-module'
import { coursesModule } from './features/courses/courses-module'
import { documentUploadsModule } from './features/document-uploads'
import { organizationMembershipsModule } from './features/organizations/organization-memberships-module'
import { organizationModule } from './features/organizations/organization-module'
import { organizationSignUpModule } from './features/organizations/organization-sign-up-module'
import { organizationTeamInviteModule } from './features/organizations/pages/organization-team-invite-module'
import { routeModule } from './features/route-module'
import { socketSessionModule } from './features/socket/socket-session-module'
import { supportChatModule } from './features/support-chat-module'
import { userStateModule } from './features/user-state/user-state-module'
import { createFolderImportModule } from './features/folder-import/create-folder-import-module'
import { magicLinksModule } from './features/magic-links'
import { runFolderImportModule } from './features/folder-import/run-folder-import-module'
import { stFolderListModule } from './features/st-folder-list/st-folder-list-module'
import { stDownloadFolderModule } from './features/st-folder-viewer/st-download-folder-module'
import { stFolderModule } from './features/st-folder-viewer/st-folder-module'
import { stSendClientOrganizerDialogModule } from './features/st-folder-viewer/st-send-client-organizer-module'
import { stAccountSettingsModule } from './features/st-organizations/st-account-settings-module'
import { clientOrganizerSettingsModule } from './slices/client-organizer-settings/module'
import { connectAppModule } from './features/st-organizations/connect-app-module'
import { stOrganizationModule } from './features/st-organizations/st-organization-module'
import { organizationIntegrationsModule } from './features/st-organizations/organization-integrations-module'
import { clientLoginFlowModule } from './features/st-questionnaire-login/client-login-flow-module'
import { snackbarModule } from './features/snackbar/snackbar-module'
import { makeContractSigningShellModule } from './features/contract-signing/contract-signing-shell-module'
import { stContractDocViewerModule } from './st-doc-viewer/runtime-definition'

const contractSigningModule = makeContractSigningShellModule(stContractDocViewerModule)

function getSTBaseProcesses() {
  return defineProcesses({
    route: routeModule,
    paymentGuide: paymentGuideModule,
    supportChat: supportChatModule,
    snackbar: snackbarModule,
    analytics: analyticsModule,
    auth: authModule,
    oauthLogin: oauthLoginModule,
    socketSession: socketSessionModule,
    userState: userStateModule,
    organization: organizationModule,
    stFolder: stFolderModule,
    contractSigning: contractSigningModule,
    clientLoginFlow: clientLoginFlowModule,
    documentUploads: documentUploadsModule
  })
}

function getSTOrganizationProcesses() {
  return defineProcesses({
    organizationMemberships: organizationMembershipsModule,
    stOrganization: stOrganizationModule,
    organizationIntegrations: organizationIntegrationsModule,
    stFolderList: stFolderListModule,
    magicLinks: magicLinksModule,
    createFolderImport: createFolderImportModule,
    clientPackets: clientPacketsModule,
    runFolderImport: runFolderImportModule,
    organizationSignUp: organizationSignUpModule,
    organizationBilling: organizationBillingModule,
    organizationTeamInvite: organizationTeamInviteModule,
    connectApp: connectAppModule,
    stAccountSettings: stAccountSettingsModule,
    clientOrganizerSettings: clientOrganizerSettingsModule,
    stSendClientOrganizer: stSendClientOrganizerDialogModule,
    stDownloadFolder: stDownloadFolderModule,
    folderOrganizerSettings: folderOrganizerSettingsModule,
    courses: coursesModule
  })
}

export type STProcessMap = ReturnType<typeof getSTBaseProcesses> &
  ReturnType<typeof getSTOrganizationProcesses>

export function stProcessesForAppType({ appType }: { appType: AppType }): STProcessMap {
  const base = getSTBaseProcesses()

  return defineProcesses(
    appType == 'organization'
      ? {
          ...base,
          ...getSTOrganizationProcesses()
        }
      : base
  ) as STProcessMap
}
